import React, { createContext, useContext, useMemo, useState } from "react";

/**
 * Per-page branding coming from the static page record on the accounts service.
 * A page sets it once its content is loaded; the layout renders the header logo
 * from it and falls back to the Mimo defaults when nothing is set.
 */
export interface Branding {
  logoUrl?: string | null;
  titleColor?: string | null;
}

export const DEFAULT_LOGO_URL = "/mimo-logo.png";

interface BrandingContextValue {
  branding: Branding;
  setBranding: (branding: Branding) => void;
}

const BrandingContext = createContext<BrandingContextValue>({
  branding: {},
  setBranding: () => undefined,
});

export const BrandingProvider = ({ children }: { children: React.ReactNode }) => {
  const [branding, setBranding] = useState<Branding>({});
  const value = useMemo(() => ({ branding, setBranding }), [branding]);
  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
